import { IPG, IPGScItem } from "@/types/summary";
import { v4 as uuidV4 } from "uuid";

export const modifyExistedSent = (sItem: IPGScItem, newContent: string) => {
  return {
    ...sItem,
    tc: newContent,
    words: [
      {
        word: newContent,
        bt: sItem.bt,
        et: sItem.et,
        wi: `w-${uuidV4()}`,
        mark: false,
      },
    ],
  };
};

export const createNewSent = (para: IPG, newContent: string, paraBt: number, paraEt: number) => {
  const newSent = {
    bt: paraBt,
    et: paraEt,
    tc: newContent,
    isEdited: true,
    transTc: "",
    id: Date.now(),
    mark: false,
    // realPara 的sc不需要维护，从UI数据结构中获取即可
    realPara: { ...para, sc: [] },
    si: `s-${uuidV4()}`,
    words: [
      {
        word: newContent,
        bt: paraBt,
        et: paraEt,
        wi: `w-${uuidV4()}`,
        mark: false,
      },
    ],
  };
  return newSent;
};

// 从前端段落数据（两个段落可能合一个）拿到后台段落数据
export const getApiDataFromUIData = (para: IPG) => {
  const resultMap = new Map<string, IPG>();
  if(para.sc.length === 0) {
    return [{...para}];
  }
  para.sc.forEach((sItem) => {
    const { realPara } = sItem;

    if (!resultMap.has(realPara.pi)) {
      const realParaScList = para.sc.filter(
        (item) => item.realPara.pi === realPara.pi
      ).map(sItem=>{
          return modifyExistedSent(sItem, sItem.tc)
      });
      resultMap.set(realPara.pi, {
        ...realPara,
        // 更新头像/发言人信息
        speakerName: para.speakerName,
        headImage: para.headImage,
        useDefaultIcon: para.useDefaultIcon,
        role: para.role,
        sc: realParaScList,
      });
    }
  });
  const apiParas = Array.from(resultMap.values()).map(item=>{
    item.sc = item.sc ? item.sc.filter(item=>item.tc.trim().length > 0) : [];
    return item;
  });
  return apiParas;
};
